import Parser from "@helpers/parser";
import { InfoRounded, ShowChartRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import * as Material from "@mui/material";

import { Text } from "@fragments";

const Metric = {
  Row: ({ children, className, noWrap, center }) => (
    <div
      className={"metric-row " + className}
      style={{
        flexWrap: noWrap ? "nowrap" : "wrap",
        alignItems: center ? "center" : "stretch",
      }}
    >
      {children}
    </div>
  ),

  OptionsSelect: ({ options, value, onChange, className }) => (
    <div className={"filter-options " + className}>
      <Material.FormControl>
        <Material.RadioGroup onChange={onChange} row value={value}>
          {options.map((opt, i) => (
            <Material.FormControlLabel
              className={
                "filter-option " + (opt.value === value && "current-option")
              }
              value={opt.value}
              control={<Material.Radio color="white" size="small" />}
              label={opt.label}
            />
          ))}
        </Material.RadioGroup>
      </Material.FormControl>
    </div>
  ),

  Box: ({
    title,
    loading,
    children,
    type = "normal",
    maxWidth = "none",
    minWidth = "none",
    titleRight = null,
    centered,
    className,
  }) => (
    <div
      className={
        "metric-box " +
        type +
        " " +
        (centered && "centered-metric") +
        " " +
        className
      }
      style={{
        maxWidth,
        minWidth,
      }}
    >
      <div className="metric-box-title px-2">
        <h4 className="py-1">{title}</h4>
        {titleRight}
      </div>
      <div className="metric-box-body px-2 py-2">{children}</div>

      {loading && (
        <div className="box-loader">
          <Material.Skeleton variant="rectangular" animation="wave" />
        </div>
      )}
    </div>
  ),

  Comparision: ({ value, type = "normal", mode = "absolute" }) => {
    const { t } = useTranslation("dashboard");

    const formatted = `${value > 0 ? "+" : ""}${value}${mode === "percent" ? "%" : ""}`;

    return (
      <div
        className={
          "comparission " + type + " " + (value >= 0 ? "positive" : "negative")
        }
      >
        <ShowChartRounded />
        <small>
          {t("dashboardPage.comparison", { value: formatted })}
        </small>
      </div>
    );
  },

  Value: ({ value, type = "text", size = "medium", className }) => {
    const text = {
      number: Parser.number(value),
      money: "R$" + Parser.price.brl(value),
      text: value,
      percent: `${Number.parseFloat(value).toFixed(2)}%`,
    }[type];
    const component = {
      large: Text.H3,
      medium: Text.H4,
      small: Text.H5,
    }[size];
    return (
      <div className={"metric-value " + className}>
        <component value={text} />
      </div>
    );
  },

  Info: ({ text, className }) => (
    <div className={"metric-info " + className}>
      <InfoRounded color="white" />
      <span>{text}</span>
    </div>
  ),
};

export default Metric;

